import { render, staticRenderFns } from "./SettingRadioGroup.vue?vue&type=template&id=14164286"
import script from "./SettingRadioGroup.vue?vue&type=script&lang=js"
export * from "./SettingRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports